import { css } from 'styled-components';
import variables from './colors/variables';

export default css`
  --bob-core-components-color-link-light: ${variables['--bob-core-components-color-link-light']};
  --bob-core-components-color-link-light-visited: ${variables[
    '--bob-core-components-color-link-light-visited'
  ]};
  --bob-core-components-color-yellow: ${variables['--bob-core-components-color-yellow']};

  --bob-core-components-color-link-dark: ${variables['--bob-core-components-color-link-dark']};
  --bob-core-components-color-link-dark-visited: ${variables[
    '--bob-core-components-color-link-dark-visited'
  ]};
  --bob-core-components-color-violet: ${variables['--bob-core-components-color-violet']};
  --bob-core-components-color-violet80: ${variables['--bob-core-components-color-violet80']};
  --bob-core-components-color-violet60: ${variables['--bob-core-components-color-violet60']};
  --bob-core-components-color-violet40: ${variables['--bob-core-components-color-violet40']};
  --bob-core-components-color-violet20: ${variables['--bob-core-components-color-violet20']};
  --bob-core-components-color-violet10: ${variables['--bob-core-components-color-violet10']};
  --bob-core-components-color-violet-darker: ${variables[
    '--bob-core-components-color-violet-darker'
  ]};

  --bob-core-components-color-mint: ${variables['--bob-core-components-color-mint']};
  --bob-core-components-color-mint80: ${variables['--bob-core-components-color-mint80']};
  --bob-core-components-color-mint60: ${variables['--bob-core-components-color-mint60']};
  --bob-core-components-color-mint40: ${variables['--bob-core-components-color-mint40']};
  --bob-core-components-color-mint20: ${variables['--bob-core-components-color-mint20']};
  --bob-core-components-color-mint10: ${variables['--bob-core-components-color-mint10']};
  --bob-core-components-color-mint-darker: ${variables['--bob-core-components-color-mint-darker']};
  --bob-core-components-color-mint-darken: ${variables['--bob-core-components-color-mint-darken']};

  --bob-core-components-color-eggplant: ${variables['--bob-core-components-color-eggplant']};
  --bob-core-components-color-eggplant80: ${variables['--bob-core-components-color-eggplant80']};
  --bob-core-components-color-eggplant60: ${variables['--bob-core-components-color-eggplant60']};
  --bob-core-components-color-eggplant40: ${variables['--bob-core-components-color-eggplant40']};
  --bob-core-components-color-eggplant20: ${variables['--bob-core-components-color-eggplant20']};
  --bob-core-components-color-eggplant10: ${variables['--bob-core-components-color-eggplant10']};
  --bob-core-components-color-eggplant-darker: ${variables[
    '--bob-core-components-color-eggplant-darker'
  ]};

  --bob-core-components-color-iris: ${variables['--bob-core-components-color-iris']};
  --bob-core-components-color-iris80: ${variables['--bob-core-components-color-iris80']};
  --bob-core-components-color-iris60: ${variables['--bob-core-components-color-iris60']};
  --bob-core-components-color-iris40: ${variables['--bob-core-components-color-iris40']};
  --bob-core-components-color-iris20: ${variables['--bob-core-components-color-iris20']};
  --bob-core-components-color-iris10: ${variables['--bob-core-components-color-iris10']};
  --bob-core-components-color-iris-darker: ${variables['--bob-core-components-color-iris-darker']};

  --bob-core-components-color-grain: ${variables['--bob-core-components-color-grain']};
  --bob-core-components-color-grain80: ${variables['--bob-core-components-color-grain80']};
  --bob-core-components-color-grain60: ${variables['--bob-core-components-color-grain60']};
  --bob-core-components-color-grain40: ${variables['--bob-core-components-color-grain40']};
  --bob-core-components-color-grain20: ${variables['--bob-core-components-color-grain20']};
  --bob-core-components-color-grain10: ${variables['--bob-core-components-color-grain10']};
  --bob-core-components-color-grain-darker: ${variables[
    '--bob-core-components-color-grain-darker'
  ]};

  --bob-core-components-color-grain-shadow-base: ${variables[
    '--bob-core-components-color-grain-shadow-base'
  ]};
  --bob-core-components-color-grain-shadow-40: ${variables[
    '--bob-core-components-color-grain-shadow-40'
  ]};

  --bob-core-components-color-lightblue-shadow-base: ${variables[
    '--bob-core-components-color-lightblue-shadow-base'
  ]};
  --bob-core-components-color-lightblue-shadow-50: ${variables[
    '--bob-core-components-color-lightblue-shadow-50'
  ]};

  // Neutrals
  --bob-core-components-color-coal: ${variables['--bob-core-components-color-coal']};
  --bob-core-components-color-sonic: ${variables['--bob-core-components-color-sonic']};
  --bob-core-components-color-ash: ${variables['--bob-core-components-color-ash']};
  --bob-core-components-color-fog: ${variables['--bob-core-components-color-fog']};
  --bob-core-components-color-platinum: ${variables['--bob-core-components-color-platinum']};
  --bob-core-components-color-snow: ${variables['--bob-core-components-color-snow']};

  // functional

  --bob-core-components-color-rosso: ${variables['--bob-core-components-color-rosso']};
  --bob-core-components-color-rosso80: ${variables['--bob-core-components-color-rosso80']};
  --bob-core-components-color-rosso60: ${variables['--bob-core-components-color-rosso60']};
  --bob-core-components-color-rosso40: ${variables['--bob-core-components-color-rosso40']};
  --bob-core-components-color-rosso20: ${variables['--bob-core-components-color-rosso20']};
  --bob-core-components-color-rosso10: ${variables['--bob-core-components-color-rosso10']};
  --bob-core-components-color-rosso-darker: ${variables[
    '--bob-core-components-color-rosso-darker'
  ]};

  --bob-core-components-color-forest: ${variables['--bob-core-components-color-forest']};
  --bob-core-components-color-forest80: ${variables['--bob-core-components-color-forest80']};
  --bob-core-components-color-forest60: ${variables['--bob-core-components-color-forest60']};
  --bob-core-components-color-forest40: ${variables['--bob-core-components-color-forest40']};
  --bob-core-components-color-forest20: ${variables['--bob-core-components-color-forest20']};
  --bob-core-components-color-forest10: ${variables['--bob-core-components-color-forest10']};
  --bob-core-components-color-forest-darker: ${variables[
    '--bob-core-components-color-forest-darker'
  ]};

  --bob-core-components-color-blue-sky: ${variables['--bob-core-components-color-blue-sky']};

  --bob-core-components-color-white-sky: ${variables['--bob-core-components-color-white-sky']};

  --bob-core-components-color-light-grey: ${variables['--bob-core-components-color-light-grey']};
  --bob-core-components-color-light-grey-2: ${variables[
    '--bob-core-components-color-light-grey-2'
  ]};

  --bob-core-components-color-lighter-grey: ${variables[
    '--bob-core-components-color-lighter-grey'
  ]};

  --bob-core-components-color-flow-button-shadow: ${variables[
    '--bob-core-components-color-flow-button-shadow'
  ]};

  --bob-core-components-color-success: ${variables['--bob-core-components-color-success']};

  --bob-core-components-color-bar-diagram-line-background: ${variables[
    '--bob-core-components-color-bar-diagram-line-background'
  ]};

  --bob-core-components-color-success-background: ${variables[
    '--bob-core-components-color-success-background'
  ]};

  --bob-core-components-color-pink-grey-background: ${variables[
    '--bob-core-components-color-pink-grey-background'
  ]};

  --bob-core-components-color-mist20: ${variables['--bob-core-components-color-mist20']};

  //gradients
  --bob-core-components-color-dawn: ${variables['--bob-core-components-color-dawn']};
  --bob-core-components-color-dusk: ${variables['--bob-core-components-color-dusk']};
  --bob-core-components-color-night: ${variables['--bob-core-components-color-night']};
`;
